<template>
  <div class="view box grow" style="overflow-y: auto">
    <page-headers
      :header="'Privileged Activity Trails'"
      :breadcrumbs="breadcrumbs"
      :is-border="true"
      documentation="page-privileged-activity-trails"
      class="box"
    ></page-headers>
    <div class="full-height" v-loading="isTrailsLoading">
      <div v-if="privilegedTrailReqStatus === 'saved'">
        <table-toolbar
          :key="trailInfoCollection.key"
          :search-properties="visibleTrailColumns"
          :total-search-properties="trailColumns"
          :search-data="trailInfoCollection"
          :initial-tags="trailInfoCollection.searchTags"
          :active-filter-data="activeFiltersData"
          :reload-component="trailInfoCollection.reloadToolbar"
          :disable-search-box="disableSearchBox"
          @update-querydata="updateTableQueryData"
          @refresh-tabledata="refreshTableData"
          @update-columns-data="modifyColumnsData"
          @add-searchtags="addSearchTags"
          @deactivate-filter="deactivateFilter"
        >
          <div slot="left-toolbar-tools" class="filter-button-group">
            <span v-if="filterList.length">
              <div class="display-inline mr-18 relative-pos" v-for="(btn, index) in filterList" :key="index">
                <el-input
                  ref="customFilterInput"
                  class="filter-input"
                  v-if="btn.editFlag"
                  placeholder="+Name"
                  v-model="btn.name"
                  @change.native.stop="handleFilterNameChange(btn)"
                  @keyup.native.enter="handleFilterNameChange(btn)"
                  @blur="handleFilterNameChange(btn)"
                ></el-input>
                <el-button
                  v-else
                  size="small"
                  round
                  :class="{'active': btn.active}"
                  :id="btn.id"
                  @click="changeState(btn)"
                >
                  {{ btn.name}}
                  <el-tooltip class="item" effect="dark" content="Edit or Delete" placement="bottom">
                  <span>
                    <i class="el-icon-edit el-icon--right" @click.stop="editFilter(btn)"></i>
                    <i class="el-icon-close el-icon--right" @click.stop="removeBtnFromList(btn, index)"></i>
                  </span>
                  </el-tooltip>
                </el-button>

                <span v-if="btn.errFlag" class="filter-name-validator">{{filterErrMsg}}</span>
              </div>
            </span>
          </div>
          <div slot="search-actions">
            <date-range-dropdown
              :disable-selection="isTrailsLoading"
              :store-pref-constant="daterangeUserPrefConstant"
              :date-range-val="privilegedActivitiesDateRangeUserSetting"
            ></date-range-dropdown>
          </div>
        </table-toolbar>
      </div>

      <action-table-element
        v-if="privilegedTrailReqStatus === 'saved'"
        ref="attacksTable"
        :columns="visibleTrailColumns"
        :table-data="trailInfoCollection"
        :height-offset="40"
        :actions="tableActions"
        @update-record-count="recordCountHandler"
      ></action-table-element>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {
  PRIVILEGED_TRAIL_REQ,
  PRIVILEGED_TRAIL_REQ_SUCCESS,
  PRIVILEGED_ACTIVITIES_TRAILS_PREFERENCES_VIEW_REQ,
  SAVE_PRIVILEGED_ACTIVITIES_TRAILS_VIEW_PREFERENCES
} from '@/store/modules/trails/trailsinfo.type'
import { PREFERENCE_STORE_REQ } from '@/store/modules/column-preference/column-preference.type'
import { AttackTrailStateEnum } from '@/constants/trail-state.constants'
import { RiskLevelEnum } from '@/constants/risk-level.constants'
import { privilegedTrailsMetaInfo } from '@/column-header/trail/privileged-trails-meta'

import PageHeaders from '@/components/layout/PageHeaders.vue'
import LineChartJs from '@/components/chart/LineChartJs.vue'
import DonutChartJs from '@/components/chart/DonutChartJs.vue'
import DonutholeChartLabelPlugin from '@/components/chart/plugins/donuthole-chart-label.plugin'
import ActionTableElement from '@/components/table/ActionTableElement.vue'
import TableToolbar from '@/components/table/TableToolbar.vue'
import DateRangeDropdown from '@/components/dropdown/DateRangeDropdown.vue'
import { PRIVILEGE_ACTIVITIES_DATE_RANGE_PREFERENCE } from '@/store/modules/user_pref/user-pref.type'
import customFilterMixin from '@/mixins/customFilterMixin'

export default {
  name: 'PrivilegedActivities',
  mixins: [customFilterMixin],
  data () {
    return {
      privilegedActivitiesColumnPrefs: {},
      tableName: "Privileged_Activity_Trails",
      daterangeUserPrefConstant: PRIVILEGE_ACTIVITIES_DATE_RANGE_PREFERENCE,
      trailColumns: privilegedTrailsMetaInfo.meta.columns,
      visibleTrailColumns: [],
      breadcrumbs: [{ title: 'Analytics' }, { title: 'Trails' }],
      trailInfoCollection: {},
      selectedAttackTrail: {},
      tableActions: [],
      tblId: 12
    }
  },
  methods: {
    getTrailListInfo (tableMetaData) {
      this.$store.dispatch(PRIVILEGED_TRAIL_REQ, { dateRangeSel: this.privilegedActivitiesDateRangeUserSetting }).then(
        trails => {
          this.trailInfoCollection = trails
          this.$store.dispatch(PRIVILEGED_TRAIL_REQ_SUCCESS)
          this.setTableMetaData(tableMetaData)
        },
        errMsg => {
          console.log(errMsg)
        }
      )
    },
    updateTableQueryData () {
      if (this.$refs.attacksTable) this.$refs.attacksTable.updateTableData()
    },
    gotoDetails (trailId) {
      this.$router.push({
        name: 'attack-track-details',
        params: { trailId: trailId }
      })
    },
    recordCountHandler () {
      // key is used to re-render TableToolbar component
      // on page change to update 'queryCountText'
      this.trailInfoCollection.key = !this.trailInfoCollection.key
      this.trailInfoCollection.reloadToolbar = false
    },
    modifyColumnsData (selectedColumns) {
      this.privilegedActivitiesColumnPrefs.userId = this.userProfile.id;
      this.privilegedActivitiesColumnPrefs.tblName = this.tableName;
      this.privilegedActivitiesColumnPrefs.preferedCols = selectedColumns.length === 0? NaN: selectedColumns;
      this.privilegedActivitiesColumnPrefs.tblId = 12; // For Mapping with database tables

      this.visibleTrailColumns = this.trailInfoCollection.updateVisibleColumns(this.trailColumns, selectedColumns)

      // store preferences in db
      this.$store.dispatch(SAVE_PRIVILEGED_ACTIVITIES_TRAILS_VIEW_PREFERENCES, this.privilegedActivitiesColumnPrefs)
        .then(data => {
          // store preferences in vuex
          this.privilegedActivitiesColumnPrefs.preferedCols = this.visibleTrailColumns;
          this.$store.dispatch(PREFERENCE_STORE_REQ, this.privilegedActivitiesColumnPrefs);
        })
    },
    callApi (tableMetaData) {
      this.getTrailListInfo(tableMetaData)
    },
    setTableMetaData (tableMetaData) {
      this.trailInfoCollection.searchTags = tableMetaData.searchTags
      this.trailInfoCollection.currentPage = tableMetaData.activePage
    },
    refreshTableData (tableMetaData) {
      this.callApi(tableMetaData)
    },
    loadPrivilegedActivitiesColumnPreferences() {
      // check if already present in store
      if (_.has(this.userPref, this.userProfile.id) && _.has(this.userPref[this.userProfile.id], this.tableName)) {
        //  read values from store
        this.visibleTrailColumns = this.userPref[this.userProfile.id][this.tableName]
        // this.updateStoreWithPrefs()
      } else {
        // fetch from database
        this.$store.dispatch(PRIVILEGED_ACTIVITIES_TRAILS_PREFERENCES_VIEW_REQ, this.userProfile.id)
          .then(data => {
            this.visibleTrailColumns = this.trailColumns.filter(col => {
              return this.privilegedActivitiesTrailsPreferences.includes(col.label)
            })
            this.updateStoreWithPrefs()
          })
      }
    },
    updateStoreWithPrefs () {
      this.privilegedActivitiesColumnPrefs = {
        userId: this.userProfile.id,
        tblName: this.tableName,
        preferedCols: this.visibleTrailColumns
      }

      this.$store.dispatch(PREFERENCE_STORE_REQ, this.privilegedActivitiesColumnPrefs);
    }
  },
  created () {
    let tableMetaData = {
      activePage: 1,
      searchTags: []
    }
    if (!this.$_.isEmpty(this.$route.query.date_range)) {
      this.$store.dispatch(this.daterangeUserPrefConstant, this.$route.query.date_range)
    }
    this.callApi(tableMetaData)
    this.loadPrivilegedActivitiesColumnPreferences()
  },
  watch: {
    privilegedActivitiesDateRangeUserSetting: {
      handler: function (newDateRange, oldDateRange) {
        if (newDateRange !== oldDateRange) {
          this.refreshTableData({
            activePage: 1,
            searchTags: this.trailInfoCollection.searchTags
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'privilegedTrailReqStatus',
      'privilegedTrailRecords',
      'privilegedActivitiesDateRangeUserSetting',
      'userProfile',
      'privilegedActivitiesTrailsPreferences',
      'userPref'
    ]),
    isTrailsLoading () {
      return this.privilegedTrailReqStatus === 'loading'
    },
    trailStatusOptions () {
      return AttackTrailStateEnum.properties
    },
    trailRiskLevelOptions () {
      return RiskLevelEnum.properties
    },
    lineChartOptions () {
      return {
        layout: {
          padding: {
            left: 10,
            right: 10
          }
        },
        tooltips: {
          enabled: true
        },
        elements: {
          point: {
            pointStyle: 'line'
          },
          line: {
            fill: true,
            backgroundColor: 'rgb(242, 248, 255)',
            borderColor: 'rgb(0, 112, 249)'
          }
        }
      }
    },
    donutLabelPlugin () {
      return DonutholeChartLabelPlugin
    },
    donutOptions () {
      return {
        cutoutPercentage: 80,
        rotation: 0.8 * Math.PI,
        circumference: 1.4 * Math.PI,
        plugins: {
          'donuthole-chart-label-plugin': {
            style: {
              circleFillColor: '#eff0f2',
              textfillColor: '#2e3344'
            }
          }
        }
      }
    }
  },
  components: {
    PageHeaders,
    LineChartJs,
    DonutChartJs,
    ActionTableElement,
    TableToolbar,
    DateRangeDropdown
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';
.el-col {
  padding-bottom: 8px;
}

.el-card {
  padding-top: 5px;
}
.trails-info {
  max-width: 65%;
  > span {
    display: block;
    padding: 2px;
  }
}
.title {
  font-size: 0.9em;
  font-weight: bold;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.info {
  font-size: 0.8em;
}

.trail-icon {
  transform: rotate(90deg);
}

.material-icons {
  font-size: 2em;
  margin-left: 10px;
}

.el-dropdown-menu.el-popper {
  .material-icons {
    font-size: 1em;
    margin-left: 0px;
  }
}

.el-card__body {
  padding: none !important;

  > div {
    margin: 5px;
  }
}

.circle {
  width: 24px;
  height: 24px;
  display: table-cell;
  border-radius: 50%;
  font-size: 15px;
  color: #fff;
  line-height: 24px;
  text-align: center;
  background: var(--primary-blue-400);
}

.el-button--mini {
  padding: 5px;
}

.view-mode {
  height: 40px;
  width: 100px;
  vertical-align: middle;
  line-height: 40px;

  .el-select:before {
    content: '\e896';
    font-family: 'Material Icons';
    font-size: 20px;
    margin-right: 16px;
    color: var(--gray-500);
    left: 50px;
    position: relative;
  }

  >>> .el-select {
    height: inherit;
    .el-input.el-input--suffix {
      visibility: hidden;
      top: -45px;
    }
  }
}

.bottom {
  border-top: 1px solid #f0f0f0;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}

.clearfix:after {
  clear: both;
}

.display-none {
  display: none;
}

.filter-button-group {
  .el-button {
    background-color: white;
    color: var(--gray-800);
    margin-bottom: 25px;

    &.active {
      background-color: var(--denim-600);
      color: white;
    }
  }

  >>> .el-input {
    input {
      border-radius: 20px;
      width: 102px;
      height: 37px;
    }
  }
}

.filter-input {
  display: table-cell;
}

>>> .search-box-container {
  position: relative;
  left: 5%;
}

.filter-name-validator {
  position: absolute;
  top: 34px;
  left: 3px;
  color: red;
  width: 110px;
}

.relative-pos {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/views/monitor/cyber_attacks/PrivilegedActivities.vue